'use client'
import * as React from 'react'
import * as Collapsible from '@radix-ui/react-collapsible'
import { tw } from 'utils/classnames'
import { useTranslations } from 'next-intl'
import { AnimatePresence, LazyMotion, domAnimation, m } from 'framer-motion'

import { useWasDownloadedState } from '@web/app/[locale]/(web)/prod/[slug]/product-asset-context'

export function DetailsContainer({ children }: React.PropsWithChildren) {
  const t = useTranslations('prod.product_description_page.buy')
  const [wasDownloaded] = useWasDownloadedState()
  const [open, setOpen] = React.useState(false)

  if (wasDownloaded) {
    return (
      <Collapsible.Root open={open} onOpenChange={setOpen}>
        <Collapsible.Trigger asChild>
          <button
            onClick={() => setOpen(open => !open)}
            className={tw('text-cf-link text-12', open && 'mb-4')}
          >
            {t('download_details')}
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={tw(
                'ml-2 inline-block transition-transform',
                open ? '-rotate-90' : 'rotate-90',
              )}
            >
              <g id="chevron_right">
                <path
                  id="Vector"
                  d="M6.47003 4L5.53003 4.94L8.58336 8L5.53003 11.06L6.47003 12L10.47 8L6.47003 4Z"
                  fill="currentColor"
                />
              </g>
            </svg>
          </button>
        </Collapsible.Trigger>

        <LazyMotion features={domAnimation}>
          <AnimatePresence>
            <Collapsible.Content asChild>
              <m.div
                initial={{ height: '0' }}
                animate={{
                  height: 'auto',
                  overflow: 'hidden',
                }}
                transition={{ duration: 0.3, type: 'tween', ease: 'easeInOut' }}
              >
                {children}
              </m.div>
            </Collapsible.Content>
          </AnimatePresence>
        </LazyMotion>
      </Collapsible.Root>
    )
  }

  return <div>{children}</div>
}
